module.exports = __webpack_public_path__ + "img/1.5b66cc45.png";